import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    applicantId: string;
};
export const schemaLoanRequestResolver_IsApplicantAdvertisementConsentAgreed = z.boolean();

export type SchemaLoanRequestResolver_IsApplicantAdvertisementConsentAgreed = z.infer<
    typeof schemaLoanRequestResolver_IsApplicantAdvertisementConsentAgreed
>;

export type LoanRequestResolver_IsApplicantAdvertisementConsentAgreed = Resolver<
    Arguments,
    SchemaLoanRequestResolver_IsApplicantAdvertisementConsentAgreed
>;
